module.exports = __webpack_public_path__ + "assets/img/bigLogo.f032ebd2.png";